import { SpaceVertical } from '@looker/components';
import type { FC } from 'react';
import type { ICustomFilter } from '../../../../../../helpers/helpers';
import { useSubGroupFilterState } from '../../../hooks/useSubGroupFilterState';
import ClinicalRecency from '../ClinicalRecency';
import { ClinicalDeciles } from '../Deciles';
import { IncludeExcludeFilter } from '../IncludeExcludeFilter';

interface ExtendedICustomFilter extends ICustomFilter {
  label: string;
  decilesFilterName?: string;
  includeExcludeFilterName: string;
  recencyFilterName: string;
  recencyLabel: string;
}

export const ClinicalFilters: FC<ExtendedICustomFilter> = (props) => {
  const {
    onChange,
    onExpressionTypeChange,
    label,
    decilesFilterName,
    includeExcludeFilterName,
    recencyFilterName,
    recencyLabel,
  } = props;

  const { handleChange } = useSubGroupFilterState(includeExcludeFilterName, onChange);

  return (
    <SpaceVertical gap="u5" height={'100%'}>
      <ClinicalRecency onMultiFilterChange={handleChange} filterName={recencyFilterName} label={recencyLabel} />
      {decilesFilterName && <ClinicalDeciles filterName={decilesFilterName} onMultiFilterChange={handleChange} />}
      <SpaceVertical height="100%">
        <IncludeExcludeFilter
          label={label}
          filterName={includeExcludeFilterName}
          onMultiFilterChange={handleChange}
          onExpressionTypeChange={onExpressionTypeChange}
        />
      </SpaceVertical>
    </SpaceVertical>
  );
};

export default ClinicalFilters;
